<template>
  <!-- 二维码弹框 -->
  <div class="trial_dialog_box" v-show="dialogShow">
    <div class="trial_dialog_mask" @click="trial_dialog_or_window_hide()"></div>
    <div class="form_box">
      <div @click="trial_dialog_or_window_hide()" class="el-icon-circle-close iconfont"></div>
      <div v-show="formShow" class="form_not_submit">
        <img class="code-img" src="@/assets/images/landing-ofd/qrCode.png" alt="" />
        <div class="code-text">扫码获取方案详情</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogShow: false,
      formShow: true,
    }
  },
  methods: {
    /**
     *显示二维码弹框
     */
    showQrCodeDialog() {
      this.dialogShow = true
    },

    // 隐藏二维码弹框
    trial_dialog_or_window_hide() {
      this.dialogShow = false
    },
  },
}
</script>

<style lang="less" scoped>
.trial_dialog_box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999999;
  // display: none;
}
.trial_dialog_box .trial_dialog_mask {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background: #000;
}

.trial_dialog_box .form_box {
  box-sizing: border-box;
  background: #e63740;
  width: 5.0133rem;
  height: 5.92rem;
  max-width: 90%;
  min-height: 288px;
  padding: 0.08rem 0.08rem 0.08rem;
  border-radius: .2133rem .2133rem .4267rem .4267rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .form_not_submit {
    .code-text {
      font-size: .4267rem;
      color: #ffffff;
      text-align: center;
      padding-top: .1867rem;
    }
  }
}

.trial_dialog_box .form_box .el-icon-circle-close {
  font-size: .5333rem;
  position: absolute;
  top: -0.48rem;
  right: -0.48rem;
  color: #c4c5c9;
  cursor: pointer;
}
</style>
